module.exports = __webpack_public_path__ + "static/GorditaBold-f2cfa59b0a631d457bdb728de763fd93.woff2";